import { StylesConfig } from "react-select";
import { COLORS } from "../../constants";
import { LojaOption } from "./types";

export const SELECT_STYLES: StylesConfig<LojaOption, false> = {
  control: (base) => ({
    ...base,
    minHeight: "38px",
    fontSize: "0.875rem",
    borderColor: COLORS.NEUTRAL_300,
    "&:hover": { borderColor: COLORS.PRIMARY },
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? COLORS.PRIMARY
      : state.isFocused
        ? COLORS.NEUTRAL_100
        : COLORS.WHITE,
    color: state.isSelected ? COLORS.WHITE : COLORS.NEUTRAL_900,
  }),
};

export const INPUT_CLASS =
  "border border-neutral-300 rounded-lg px-2 sm:px-3 py-2 text-xs sm:text-sm focus:ring-2 focus:ring-primary focus:border-transparent w-full sm:w-auto";
export const LABEL_CLASS =
  "text-xs sm:text-sm font-medium text-neutral-700 whitespace-nowrap";
